import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class NotesValidator {
  constructor() {}

  notesValidator(
    formField: AbstractControl
  ): { [key: string]: any } | null | void {
    
    // Check if field is Required
    const isEmpty = (formField.value === '') || (formField.value === null) || (formField.value === undefined);;

    // Must only be letters, numbers, spaces and these symbols '-,',/'
    const allowedCharacters = /^$|^[0-9a-zA-Z\:\,\.\*\+\$\@\!\?\&\%\(\)\=\"\'\/\-\s]+$/.test(
      formField.value
    );
    // console.log('allowedCharacters: ', allowedCharacters);
    if (!isEmpty && !allowedCharacters) {
      return { notAllowed: { valid: false, value: formField.value } };
    }
  }
}
